export const SET_HRES80X_COLUMNS = 'SET_HRES80X_COLUMNS'
export const GET_HRES80X_COLUMNS = 'GET_HRES80X_COLUMNS'

export const SET_HRES80X_LABELS = 'SET_HRES80X_LABELS'
export const GET_HRES80X_LABELS = 'GET_HRES80X_LABELS'
export const RECEIVED_HRES80X_COLUMNS_LABELS = 'RECEIVED_HRES80X_COLUMNS_LABELS'

export const SET_HRES80X_HISHEAL = 'SET_HRES80X_HISHEAL'
export const GET_HRES80X_HISHEAL = 'GET_HRES80X_HISHEAL'
export const GET_HRES80X_HISHEAL_DETAIL = 'GET_HRES80X_HISHEAL_DETAIL'
export const GET_HRES80X_HISHEAL_FAMILY = 'GET_HRES80X_HISHEAL_FAMILY'
export const GET_HRES80X_HEAL_CHECKUP_HEADER = 'GET_HRES80X_HEAL_CHECKUP_HEADER'
export const GET_HRES80X_HEAL_CHECKUP_DETAIL = 'GET_HRES80X_HEAL_CHECKUP_DETAIL'
export const GET_HRES80X_HEAL_CHECKUP_ROWS = 'GET_HRES80X_HEAL_CHECKUP_ROWS'
export const RECEIVED_HRES80X_HISHEAL = 'RECEIVED_HRES80X_HISHEAL'



// WEBPACK FOOTER //
// ./src/store/modules/hres80x/mutation-types.js